import { createRouter, createWebHashHistory } from 'vue-router';

const routes = [
  {
    name: 'login',
    path: '/login',
    component:()=>import('@/view/login/'),
    meta: {
      title: '员工登录',
      roles: ['管理员','财务','行政','普通员工','仓库','总经理','开单','宇凯仓库'],
    },
  },
  {
    name: 'employee',
    path: '/employee',
    component:()=>import('@/view/employee'),
    meta: {
      title: '员工列表',
      auth:true,
      roles: ['管理员','行政','总经理'],
    },
  },
  {
    name: 'boundsearch',
    path: '/boundsearch',
    component:()=>import('@/view/boundsearch'),
    meta: {
      title: '库存查询',
      auth:true,
      roles: ['管理员','仓库','总经理','宇凯仓库'],
    },
  },
  {
    name: 'shelvessearch',
    path: '/shelvessearch',
    component:()=>import('@/view/shelvessearch'),
    meta: {
      title: '货架查询',
      auth:true,
      roles: ['管理员','仓库','总经理','宇凯仓库'],
    },
  },
  {
    name: 'statistics',
    path: '/statistics',
    component:()=>import('@/view/statistics'),
    meta: {
      title: '仓储统计',
      auth:true,
      roles: ['管理员','仓库','总经理','宇凯仓库'],
    },
  },
  {
    name: 'course',
    path: '/course',
    component:()=>import('@/view/course'),
    meta: {
      title: '出入库记录',
      auth:true,
      roles: ['管理员','仓库','总经理'],
    },
  },
  {
    name: 'vehicle',
    path: '/vehicle',
    component:()=>import('@/view/vehicle'),
    meta: {
      title: '车辆',
      auth:true,
      roles: ['管理员','仓库','总经理'],
    },
  },
  {
    name: 'attend',
    path: '/attend',
    component:()=>import('@/view/attend'),
    meta: {
      title: '考勤',
      auth:true,
      roles: ['管理员','财务','行政','普通员工','仓库','开单'],
    },
  },
  {
    name: 'graspmanagement',
    path: '/graspmanagement',
    component:()=>import('@/view/graspmanagement'),
    meta: {
      title: '经营历程',
      auth:true,
      roles: ['管理员','总经理','开单'],
    },
  },
  {
    name: 'inventory',
    path: '/inventory',
    component:()=>import('@/view/inventory'),
    meta: {
      title: '库存状况',
      auth:true,
      roles: ['管理员','总经理','开单'],
    },
  },
  {
    name: 'graspoldarap',
    path: '/graspoldarap',
    component:()=>import('@/view/graspoldarap'),
    meta: {
      title: '应收应付(旧)',
      auth:true,
      roles: ['管理员','总经理'],
    },
  },
  {
    name: 'grasparap',
    path: '/grasparap',
    component:()=>import('@/view/grasparap'),
    meta: {
      title: '应收应付',
      auth:true,
      roles: ['管理员','总经理','开单'],
    },
  },
  {
    path: '/',
    component: () => import('@/view/Tabbar/'),
    meta: {
      auth:true,
      roles: ['管理员','财务','行政','普通员工','仓库','总经理','开单','宇凯仓库'],
    },
    children:[
      {
        name: 'main',
        path: '/main',
        component: () => import('@/view/main/'),
        meta: {
          title: '控制台',
          auth: true,
          roles: ['管理员','财务','行政','普通员工','仓库','总经理','开单','宇凯仓库'],
        },
      },
      {
        name: 'goods',
        path: '/addbook',
        component: () => import('@/view/addbook/'),
        meta: {
          title: '通讯录',
          auth: true,
          roles: ['管理员','财务','行政','普通员工','仓库','总经理','开单','宇凯仓库'],
        },
      },
      {
        name: 'my',
        path: '/my',
        component: () => import('@/view/my/'),
        meta: {
          title: '我的',
          auth: true,
          roles: ['管理员','财务','行政','普通员工','仓库','总经理','开单','宇凯仓库'],
        },
      },
    ]
  },
  {
    name: '404',
    path: '/404',
    component:()=>import('@/view/404'),
    meta: {
      title: '权限不足',
      roles: ['管理员','财务','行政','普通员工','仓库','总经理','开单','宇凯仓库'],
    },
  },
];

const router = createRouter({
  routes,
  history: createWebHashHistory(),
});

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  // 检查当前路由或其父路由是否需要登录验证
  const requiresAuth = to.matched.some(record => record.meta.auth)
  if (!requiresAuth) return next()
  // 检查是否已登录
  const userStr = localStorage.getItem('user')
  if (!userStr) return next('/login')
  // 检查角色权限
  const roleStr = localStorage.getItem('roles')
  if (to.meta.roles && to.meta.roles.includes(roleStr)) {
    next()
  } else {
    next({ path: '/404' })
  }
});

export { router };
